import React from 'react'
import styles from './index.module.css'

export type HoverContainerProps = {
  className?: string
  style?: React.CSSProperties
  children: React.ReactNode
  as?: any
  disabled?: boolean
}

export const HoverContainer = ({ children, as, className = '', disabled, style }: HoverContainerProps) => {
  const As = as ?? 'div'
  let hoverContainerClassName = styles.hoverContainer

  //if disabled, don't show the context menu
  if (disabled) hoverContainerClassName = ''

  return (
    <As className={`${hoverContainerClassName} ${className}`} style={style}>
      {children}
    </As>
  )
}

export type HoverMenuContainerProps = { children: React.ReactNode; pinned?: boolean; className?: string }

// `pinned` keeps the menu revealed after the pointer leaves, for a menu whose popover is anchored to it.
export const HoverMenuContainer = ({ children, pinned, className = '' }: HoverMenuContainerProps) => {
  return <div className={`${pinned ? styles.hoverMenuPinned : styles.hoverMenu} ${className}`}>{children}</div>
}
